module.exports = "<h1 class=\"confirm-modal\" md-dialog-title>Confirmation</h1>\r\n<p class=\"question\" translate>\r\n  {{ question }}\r\n</p>\r\n<div class=\"row justify-content-end\">\r\n  <button class=\"decline\" md-button md-dialog-close=\"Decline\" translate>Decline</button>\r\n  <button class=\"accept\" md-button md-dialog-close=\"Accept\" translate>Accept</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/shared/confirm-modal/confirm-modal.component.html
// module id = ../../../../../src/app/shared/confirm-modal/confirm-modal.component.html
// module chunks = 2